import type { EntityGraphNode } from "../../../../core/engine/EntityGraphNode/EntityGraphNode.type"
import type { DeadwoodEntity } from "../../../../core/entity/EntityType/Deadwood"
import getManhattanDistance from "../../../../core/tile_position_xy/getManhattanDistance"

type DeadwoodCluster = Array<EntityGraphNode<DeadwoodEntity>>
type DeadwoodClusterList = Array<DeadwoodCluster>

// Step 1: Create initial clusters based on adjacency
export default function createInitialDeadwoodClusters(
  entities: DeadwoodCluster
): DeadwoodClusterList {
  const visited = new Set<number>()
  const chunks: DeadwoodClusterList = []

  function floodFill(start: EntityGraphNode<DeadwoodEntity>, cluster: DeadwoodCluster) {
    const stack = [start]
    visited.add(start.id)

    while (stack.length > 0) {
      const currentEntNode = stack.pop()!
      const currentEnt = currentEntNode.raw()
      cluster.push(currentEntNode)

      for (const otherEntNode of entities) {
        if (!visited.has(otherEntNode.id) && getManhattanDistance(currentEnt, otherEntNode.raw()) === 1) {
          visited.add(otherEntNode.id)
          stack.push(otherEntNode)
        }
      }
    }
  }

  for (const entityNode of entities) {
    if (!visited.has(entityNode.id)) {
      const cluster: DeadwoodCluster = []
      floodFill(entityNode, cluster)
      chunks.push(cluster)
    }
  }
  return chunks
}